"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterCellsByInputs = void 0;
const filterCellsByInputs = (cells, inputs) => {
    return inputs.map(input => {
        const outPoint = input.previousOutput;
        const cell = cells.find(c => { var _a, _b; return ((_a = c.outPoint) === null || _a === void 0 ? void 0 : _a.txHash) === (outPoint === null || outPoint === void 0 ? void 0 : outPoint.txHash) && ((_b = c.outPoint) === null || _b === void 0 ? void 0 : _b.index) === (outPoint === null || outPoint === void 0 ? void 0 : outPoint.index); });
        if (!cell) {
            throw new Error(`Cell of ${JSON.stringify(outPoint)} is not found`);
        }
        return cell;
    });
};
exports.filterCellsByInputs = filterCellsByInputs;
exports.default = { filterCellsByInputs: exports.filterCellsByInputs };
//# sourceMappingURL=utils.js.map